import { render, staticRenderFns } from "./stock-table.vue?vue&type=template&id=1a09a934&scoped=true"
import script from "./stock-table.vue?vue&type=script&lang=js"
export * from "./stock-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a09a934",
  null
  
)

export default component.exports